/**
 * Stored on each team document as `division` (legacy field name).
 */
export const SUBSCRIPTION_TYPE_OPTIONS = [
  "Executive",
  "NCAA",
  "All-Inclusive",
];

/** No longer offered; omit from filter lists and standard selects. */
const EXCLUDED_SUBSCRIPTION_NORMALIZED = new Set(["division 1", "division i"]);

export function isExcludedSubscriptionType(value) {
  if (value == null || String(value).trim() === "") return false;
  return EXCLUDED_SUBSCRIPTION_NORMALIZED.has(String(value).trim().toLowerCase());
}

export const ALL_SUBSCRIPTION_TYPES = "All subscription types";
